import React from 'react';

const TrendItem = React.memo(({ label, value, trend, change }) => {
  const getTrendIcon = (trend) => {
    switch (trend) {
      case 'up': return '📈';
      case 'down': return '📉';
      default: return '➡️';
    }
  };
  
  return (
    <div className="text-center p-3 bg-gray-50 rounded-lg">
      <div className="text-lg font-bold text-gray-900">{value}</div>
      <div className="text-xs text-gray-600">{label}</div>
      <div className="flex items-center justify-center mt-1">
        <span className="text-xs">{getTrendIcon(trend)}</span>
        <span className="text-xs ml-1">{change > 0 ? '+' : ''}{change}</span>
      </div>
    </div>
  );
});

export default TrendItem;
